module.exports = __webpack_public_path__ + "img/9@2x.4f614c73.png";